// Meta configuration IDs are public identifiers used by the browser to choose
// the permission bundle configured in Facebook Login for Business. They are not
// access tokens or app secrets.
export const FACEBOOK_SIGN_IN_CONFIG_ID = '1037364738668865';
export const FACEBOOK_PAGE_CONFIG_ID = '941742048940779';

export const FACEBOOK_SIGN_IN_SCOPES = [
  'email',
  'pages_show_list',
];
